import { useMemo } from 'react'

export const useDuplicatedArray = <T>(arr: T[], minLength: number): T[] => {
  return useMemo(() => {
    if (!Array.isArray(arr) || arr.length === 0) {
      return arr
    }

    const dupeTimes = Math.ceil(minLength / arr.length)

    if (dupeTimes === 1) {
      return arr
    }

    const duped: T[] = []

    for (let i = 0; i < dupeTimes; i++) {
      duped.push(...arr)
    }

    return duped
  }, [arr, minLength])
}
